import './App.css';
import {MyDropzone} from './DropZone/dropzone';
import { AppProvider } from './ThemeLangContext';

function App() {
    return (
        <AppProvider>
            <div className="App">
                <MyDropzone />
            </div>
        </AppProvider>
    );
}

export default App;
